import React, { useState, useEffect } from "react";

function QuantityPricing({ onCheckout }) {
  const [quantity, setQuantity] = useState(1);
  const [unitPrice, setUnitPrice] = useState(29.9); // preço base
  const [total, setTotal] = useState(29.9);

  // 🔥 regras de preço por faixa (AJUSTA AQUI)
  const pricingRules = [
    { min: 1, max: 9, price: 49.9 },
    { min: 10, max: 30, price: 46.9 },
    { min: 31, max: 999, price: 39.9 },
  ];

  // 👉 define preço por faixa
  const getUnitPrice = (qty) => {
    const rule = pricingRules.find(
      (r) => qty >= r.min && qty <= r.max
    );
    return rule ? rule.price : pricingRules[0].price;
  };

  // 👉 recalcula tudo quando muda quantidade
  useEffect(() => {
    const price = getUnitPrice(quantity);
    setUnitPrice(price);
    setTotal(price * quantity);
  }, [quantity]);

  // 👉 controle de quantidade
  const increase = () => setQuantity((prev) => prev + 1);

  const decrease = () => {
    if (quantity > 1) setQuantity((prev) => prev - 1);
  };

  const handleChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setQuantity(value);
  };

  // 👉 botão final
  const handleCheckout = () => {
    if (onCheckout) {
      onCheckout({
        quantity,
        unitPrice,
        total,
      });
    }
  };

  return (
    <div className="qp-container">
      <h3 className="qp-title">Escolha a metragem</h3>

      {/* CONTROLE */}
      <div className="qp-controls">
        <button onClick={decrease} className="qp-btn">-</button>

        <input
          type="number"
          value={quantity}
          onChange={handleChange}
          min="1"
          className="qp-input"
        />

        <button onClick={increase} className="qp-btn">+</button>
      </div>

      {/* INFO PREÇO */}
      <div className="qp-pricing">
        <p>
          Valor por metro: <strong>R$ {unitPrice.toFixed(2)}</strong>
        </p>

        <p className="qp-total">
          Total: <strong>R$ {total.toFixed(2)}</strong>
        </p>
      </div>

      {/* CTA */}
      <button className="qp-checkout" onClick={handleCheckout}>
        Comprar Agora
      </button>

      {/* FAIXAS VISUAIS */}
      {/* <div className="qp-rules">
        <p>💡 Desconto progressivo:</p>
        <ul>
          {pricingRules.map((r, index) => (
            <li key={index}>
              {r.min} a {r.max === 999 ? "+" : r.max} metros → R$ {r.price}
            </li>
          ))}
        </ul>
      </div> */}
    </div>
  );
}

export default QuantityPricing;